import { useState } from "react";
import DatePicker , { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_en from "react-date-object/locales/persian_en";
import persian_fa from "react-date-object/locales/persian_fa";
import English from "react-date-object/locales/gregorian_en";
import gregorian from "react-date-object/calendars/gregorian";
import type{Value} from "react-multi-date-picker";
import { useField } from "formik";
type Props = {
  value: string;
};

function Datepicker({value}: Props) {
  //const [value, setValue] = useState<Value>(new Date());
  const [field, meta, { setValue }] = useField("dateOfBirth");
  
  return (
    <div className="datepicker">
      <DatePicker
        placeholder="تاریخ تولد"
        calendar={persian}
        locale={persian_fa}
        onFocusedDateChange={(focusedDate, clickedDate) => {
          // console.log(focusedDate?.format?.(), clickedDate?.format?.());
          console.log(focusedDate?.convert(gregorian , English )?.format?.())
          setValue(focusedDate?.convert(gregorian , English )?.format?.())
        }}
      />
    </div>
  );
}

export default Datepicker;
